// extracted by mini-css-extract-plugin
export default {"container":"style_container__f9u7f","tagsMain":"style_tagsMain__OLC0p","tags":"style_tags__ldXfV"};